import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SplashScreen } from 'src/components/loading-screen';
import { setFilterDate } from 'src/context/reducers/filter-settings/filterSlice';
import { getLast12WeeksDateRange } from 'src/utils/format-time';
import ClusterManager from './cluster-manager';
import { NONBRAND_CLUSTER_CONFIG } from './config';
import { useNonBrandCountries } from './use-nonbrand-countries';

/**
 * Non Brand > Search Performance > Cluster Manager.
 * Like the Non Brand Overview it opens on the last 12 complete weeks; the grid
 * and the country tabs wait for that range instead of querying the previous page's.
 */
export default function NonBrandClusterManager() {
  const dispatch = useDispatch();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const { start, end } = getLast12WeeksDateRange();
    // skipAlignment: another page (Search Performance) may leave timestep=year_month,
    // which would snap the 12-week start to the 1st of the month.
    dispatch(setFilterDate({ start, end, skipAlignment: true }));
    setReady(true);
  }, [dispatch]);

  const { countries, isLoading } = useNonBrandCountries(ready);

  if (!ready) return <SplashScreen />;

  return <ClusterManager config={NONBRAND_CLUSTER_CONFIG} countries={countries} isLoadingCountries={isLoading} />;
}
